import React from 'react';
import PropTypes, { number, string, bool } from 'prop-types';
import chunk from 'lodash/chunk';

import { InventoryGridRow } from './InventoryGridRow';

export function InventoryGridView(props) {
  const {
    currentPageInventoryItems,
    hideActions,
    handleAddToPickList,
    handleShowImage,
    isItemInDraftPickList,
  } = props;

  const chunkedPageItems = chunk(currentPageInventoryItems, 4);
  return (
    <div className="inventory-grid">
      {chunkedPageItems.map((row) => (
        <InventoryGridRow
          chunkedRow={row}
          hideActions={hideActions}
          isItemInDraftPickList={isItemInDraftPickList}
          handleAddToPickList={handleAddToPickList}
          handleShowImage={handleShowImage}
        />
      ))}
    </div>
  );
}

InventoryGridView.defaultProps = {
  currentPageInventoryItems: [],
  hideActions: false,
};

InventoryGridView.propTypes = {
  handleAddToPickList: PropTypes.func.isRequired,
  handleShowImage: PropTypes.func.isRequired,
  isItemInDraftPickList: PropTypes.func.isRequired,
  hideActions: PropTypes.bool,
  currentPageInventoryItems: PropTypes.arrayOf(
    PropTypes.shape({
      IsDelivered: bool,
      ShipmentNumner: number,
      InventoryItemID: string,
      ItemTag: string,
      LotID: string,
      Comments: string,
      StorageItemID: number,
      RoomID: string,
      RoomName: string,
      RoomComments: string,
      LocationID: string,
      LocaitonName: string,
      IsLocLocked: bool,
      Percentage: number,
      TotalItemInLocation: number,
      LocationTypeID: number,
      IsHighValue: bool,
      Value: number,
      Customer_ID: number,
      IsItemActive: bool,
      IsVoided: bool,
      Cube: number,
      InventoriedByID: number,
      BingoedByID: number,
      PreppedByID: number,
      LoadedByID: number,
      Height: number,
      Length: number,
      Width: number,
      ili: PropTypes.arrayOf(
        PropTypes.shape({
          LotName: string,
          IsLodLocked: bool,
          HasStorageItemID: number,
          DispLocID: string,
          Warehouse: string,
          InventoriedByName: string,
          BingoedByName: string,
          PreppedByName: string,
          LoadedByName: string,
          ImageCount: number,
          FirstImage: string,
        })
      ),
    })
  ),
};
